import * as React from "react";
import { FaCaretDown, FaAngleDoubleRight } from "react-icons/fa";
import { MdMenu, MdLanguage } from "react-icons/md";
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Navbar as RNavbar, NavbarBrand } from "reactstrap";
import { Language, LocalizeContextProps, withLocalize, Translate } from "react-localize-redux";
import logo from "../assets/netvisor_logo_2019_RGB.svg";
import "./Navbar.scss";
import Stepper from "./Stepper";

interface IState {
  langDropdownOpen: boolean;
  sideMenuVisible: boolean;
}

type IProps = {
  current: 1 | 2 | 3;
  finishedEnabled?: boolean;
  isContactRequest?: boolean;
  language: Language;
  languageChanged: any;
  onPreviousOffer?: any;
  summaryEnabled?: boolean;
  translate: any;
} & LocalizeContextProps;

class Navbar extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      langDropdownOpen: false,
      sideMenuVisible: false
    };

    this.handleExistingClick = this.handleExistingClick.bind(this);
    this.handleLangClick = this.handleLangClick.bind(this);
    this.toggleLangDropdown = this.toggleLangDropdown.bind(this);
    this.toggleSideMenu = this.toggleSideMenu.bind(this);
  }

  public render() {
    if (process.env.REACT_APP_FE_MODE === "embed") {
      return (
        <RNavbar className="bg-white shadow-sm" light={true}>
          <div className="container p-0 pr-md-4 pl-md-4">
            <NavbarBrand className="mr-0 netvisor-logo" style={{ backgroundImage: "url(" + logo + ")" }} />
            <div className="d-none d-md-flex">
              <Stepper current={this.props.current} isContactRequest={this.props.isContactRequest} summaryEnabled={this.props.summaryEnabled} finishedEnabled={this.props.finishedEnabled} />
            </div>
            <div className="align-items-center row d-none d-md-flex" />
          </div>
        </RNavbar>
      );
    } else {
      return (
        <RNavbar className="bg-white shadow-sm" light={true}>
          <div className="container p-0 pr-md-4 pl-md-4">
            <NavbarBrand className="mr-0 netvisor-logo" style={{ backgroundImage: "url(" + logo + ")" }} />
            <div className="d-none d-md-flex">
              <Stepper current={this.props.current} isContactRequest={this.props.isContactRequest} summaryEnabled={this.props.summaryEnabled} finishedEnabled={this.props.finishedEnabled} />
            </div>
            <div className="align-items-center row d-none d-md-flex">
              <div className="border-left mr-3 d-none d-lg-block" style={{ height: "30px" }} />
              <Dropdown isOpen={this.state.langDropdownOpen} toggle={this.toggleLangDropdown}>
                <DropdownToggle>
                  <MdLanguage className="lang mr-2" />
                  {this.props.language.name}
                  <FaCaretDown className="ml-2" />
                </DropdownToggle>
                <DropdownMenu right={true}>
                  {this.props.languages.map((lang: Language, idx: number) => {
                    return (
                      <DropdownItem key={idx} className={this.props.language.name === lang.name ? "active" : ""} onClick={this.handleLangClick} data-langcode={lang.code} data-langname={lang.name}>
                        {lang.name}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="d-flex d-md-none">
              <MdMenu onClick={this.toggleSideMenu} className="menuhamburger" />
            </div>
          </div>
          <div className={"navbar-side " + (this.state.sideMenuVisible ? "reveal" : "")}>
            <div className="nav-header p-3 d-flex justify-content-between">
              <span className="menutitle">
                <Translate id="Menu" />
              </span>
              <Button close={true} onClick={this.toggleSideMenu} />
            </div>
            <div className="p-3">
              <a className="netvisor-link d-flex align-items-center" onClick={this.handleExistingClick}>
                <span className="mr-2">
                  <Translate id="EditExistingOffer" />
                </span>
                <FaAngleDoubleRight />
              </a>
              <hr className="thick" />
              <h3 className="d-flex align-items-center">
                <span>
                  <Translate id="ChangeLang" />
                </span>{" "}
                <MdLanguage className="ml-2 lang-icon" />
              </h3>
              {this.props.languages.map((lang: Language, idx: number) => (
                <div key={idx}>
                  <hr />
                  <div className={"lang pl-2 " + (this.props.language.name === lang.name ? "active" : "")} data-langcode={lang.code} data-langname={lang.name} onClick={this.handleLangClick}>
                    {lang.name}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={"overlay " + (this.state.sideMenuVisible ? "d-block" : "")} onClick={this.toggleSideMenu} />
        </RNavbar>
      );
    }
  }

  private toggleSideMenu() {
    const sideMenuVisible = !this.state.sideMenuVisible;
    if (sideMenuVisible) {
      document.body.classList.add("sideMenuOpen");
    } else {
      document.body.classList.remove("sideMenuOpen");
    }
    this.setState({ sideMenuVisible });
  }

  private toggleLangDropdown(event?: any) {
    this.setState((prevState: IState) => ({
      langDropdownOpen: !prevState.langDropdownOpen
    }));
  }

  private handleLangClick(event: React.MouseEvent<any>) {
    if (event.currentTarget && event.currentTarget.dataset && event.currentTarget.dataset.langcode) {
      this.props.languageChanged({
        code: event.currentTarget.dataset.langcode || "",
        name: event.currentTarget.dataset.langname || ""
      });
    }

    if (this.state.sideMenuVisible) {
      this.toggleSideMenu();
    }
  }

  private handleExistingClick() {
    if (typeof this.props.onPreviousOffer === "function") {
      this.props.onPreviousOffer();
    }

    if (this.state.sideMenuVisible) {
      this.toggleSideMenu();
    }
  }
}

export default withLocalize(Navbar);
